import { Button, styled } from "@mui/material";

const DefaultButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  lineHeight: 1.2,
  fontSize: "13px",
  padding: "8px 14px",
  "&:not(:disabled)": {
    border: `1px solid ${theme.palette.primary.main}80`,
  },
  "&:disabled": {
    border: `1px solid ${theme.palette.divider}`,
  },
  "&.alignEnd": {
    alignSelf: "end",
  },
  "&.alignStart": {
    alignSelf: "start",
  },
  "&.fullWidth": {
    width: "100%",
  },
}));

export default DefaultButton;
